export default __webpack_public_path__ + "static/media/english-to-polish-screenshot-06.690db14c.png";